/* tslint:disable:no-default-export */
import {
  ACCOUNT_ACTION_IDS,
  ACCOUNT_EVENT_IDS,
  AccountActionTypes,
  AccountActionsRequest,
} from '@central-products/interface-account-actions';
import { shouldShowDCF, RulesPayload } from '@dcf/display-rules';
import { ConfigArguments } from '../../types';

export default {
  [ACCOUNT_EVENT_IDS.DEPOSIT_REQUIRED]: (config: ConfigArguments, payload?: AccountActionsRequest['context']) => {
    if (config.dcf && payload && shouldShowDCF(config.dcf, payload as RulesPayload)) {
      return {
        actionId: ACCOUNT_ACTION_IDS.DCF_START,
        actionType: AccountActionTypes.USER_FLOW,
        pathToData: 'countryCode',
      };
    }

    return {
      actionId: ACCOUNT_ACTION_IDS.DEPOSIT_START,
      actionType: AccountActionTypes.REDIRECT,
      pathToData: 'data',
      defaultData: {
        desktop:
          'https://sports.williamhill{env}.com/acc/{obLang}/payment/deposit/{depositHtmlPage}.html?hide_header=1&source={regSource}',
        mobile:
          'https://sports.williamhill{env}.com/mob/{obLang}/payment/deposit/{depositHtmlPage}.html?hide_header=1&source={regSource}',
      },
    };
  },
  [ACCOUNT_EVENT_IDS.RECOVER_REQUESTED]: {
    actionId: ACCOUNT_ACTION_IDS.RECOVER_START,
    actionType: AccountActionTypes.REDIRECT,
    pathToData: 'data',
    defaultData: 'https://myaccount.williamhill{env}.com/recovery/{lang}?closeBtn=false',
  },
  [ACCOUNT_EVENT_IDS.REOPEN_REQUESTED]: {
    actionId: ACCOUNT_ACTION_IDS.REOPEN_START,
    actionType: AccountActionTypes.REDIRECT,
    pathToData: 'data',
    defaultData: 'https://myaccount.williamhill{env}.com/recovery/reopen/{lang}?closeBtn=false',
  },
  [ACCOUNT_EVENT_IDS.RESET_PASSWORD_REQUIRED]: {
    actionId: ACCOUNT_ACTION_IDS.RESET_PASSWORD_START,
    actionType: AccountActionTypes.REDIRECT,
    pathToData: 'data',
    defaultData: {
      desktop: 'https://sports.williamhill{env}.com/acc/{lang}?action=GoUpdatePwd&modal_reg=0&target_page=',
      mobile: 'https://sports.williamhill{env}.com/mob/{lang}?action=GoUpdatePwd&modal_reg=0&target_page=',
    },
  },
  [ACCOUNT_EVENT_IDS.FAQ_PAGE_REQUESTED]: {
    actionId: ACCOUNT_ACTION_IDS.FAQ_PAGE_OPEN,
    actionType: AccountActionTypes.REDIRECT,
    pathToData: 'data',
  },
  [ACCOUNT_EVENT_IDS.LIVE_CHAT_REQUESTED]: {
    actionId: ACCOUNT_ACTION_IDS.LIVE_CHAT_OPEN,
    actionType: AccountActionTypes.REDIRECT,
    pathToData: 'data',
  },
  [ACCOUNT_EVENT_IDS.LOGIN_REQUESTED]: {
    actionId: ACCOUNT_ACTION_IDS.LOGIN_START,
    actionType: AccountActionTypes.USER_FLOW,
    pathToData: 'data',
  },
  [ACCOUNT_EVENT_IDS.REGISTRATION_REQUESTED]: {
    actionId: ACCOUNT_ACTION_IDS.REGISTRATION_START,
    actionType: AccountActionTypes.USER_FLOW,
    pathToData: 'data',
  },
  [ACCOUNT_EVENT_IDS.API_CALL_INVALID]: {
    actionId: ACCOUNT_ACTION_IDS.MESSAGE_LOG,
    actionType: AccountActionTypes.DEBUG_MESSAGE,
  },
  [ACCOUNT_EVENT_IDS.INVALID_STATE]: {
    actionId: ACCOUNT_ACTION_IDS.MESSAGE_LOG,
    actionType: AccountActionTypes.DEBUG_MESSAGE,
  },
  [ACCOUNT_EVENT_IDS.OPERATION_FAILED]: {
    actionId: ACCOUNT_ACTION_IDS.MESSAGE_LOG,
    actionType: AccountActionTypes.DEBUG_MESSAGE,
  },
  [ACCOUNT_EVENT_IDS.WELCOME_MESSAGES_REQUESTED]: {
    actionId: ACCOUNT_ACTION_IDS.WELCOME_MESSAGES_OPEN,
    actionType: AccountActionTypes.USER_FLOW,
    pathToData: 'data',
  },
  [ACCOUNT_EVENT_IDS.WELCOME_MESSAGES_CAMPAIGN_DISPLAYED]: {
    actionId: ACCOUNT_ACTION_IDS.WELCOME_MESSAGES_CAMPAIGN_DISPLAYED,
    actionType: AccountActionTypes.USER_FLOW,
    pathToData: 'data',
  },
  [ACCOUNT_EVENT_IDS.WELCOME_MESSAGES_NAVIGATE_REQUESTED]: {
    actionId: ACCOUNT_ACTION_IDS.NAVIGATE_TO,
    actionType: AccountActionTypes.REDIRECT,
    pathToData: 'data',
  },
  [ACCOUNT_EVENT_IDS.WELCOME_MESSAGES_OPTIN_REQUESTED]: {
    actionId: ACCOUNT_ACTION_IDS.WELCOME_MESSAGES_OPTIN_EXECUTE,
    actionType: AccountActionTypes.USER_FLOW,
    pathToData: 'data',
  },
  [ACCOUNT_EVENT_IDS.BETSLIP_REQUESTED]: {
    actionId: ACCOUNT_ACTION_IDS.OPEN_BETSLIP,
    actionType: AccountActionTypes.REDIRECT,
    pathToData: 'data',
  },
  [ACCOUNT_EVENT_IDS.PLACE_BET_REQUESTED]: {
    actionId: ACCOUNT_ACTION_IDS.PLACE_BET,
    actionType: AccountActionTypes.REDIRECT,
    pathToData: 'data',
  },
  [ACCOUNT_EVENT_IDS.LAUNCH_GAME_REQUESTED]: {
    actionId: ACCOUNT_ACTION_IDS.LAUNCH_GAME,
    actionType: AccountActionTypes.REDIRECT,
    pathToData: 'data',
  },
  [ACCOUNT_EVENT_IDS.HARD_FLAG_REQUESTED]: {
    actionId: ACCOUNT_ACTION_IDS.HARD_FLAG_START,
    actionType: AccountActionTypes.USER_FLOW,
    pathToData: 'data',
  },
  [ACCOUNT_EVENT_IDS.SOFT_FLAG_REQUESTED]: {
    actionId: ACCOUNT_ACTION_IDS.SOFT_FLAG_START,
    actionType: AccountActionTypes.USER_FLOW,
    pathToData: 'data',
  },
  [ACCOUNT_EVENT_IDS.ACCOUNT_FLAG_CLOSE_REQUESTED]: {
    actionId: ACCOUNT_ACTION_IDS.ACCOUNT_FLAG_CLOSE,
    actionType: AccountActionTypes.USER_FLOW,
    pathToData: 'data',
  },
  [ACCOUNT_EVENT_IDS.ACCOUNT_FLAG_SUCCESS_REQUESTED]: {
    actionId: ACCOUNT_ACTION_IDS.ACCOUNT_FLAG_SUCCESS,
    actionType: AccountActionTypes.USER_FLOW,
    pathToData: 'data',
  },
  [ACCOUNT_EVENT_IDS.ACCOUNT_FLAG_QUIT_REQUESTED]: {
    actionId: ACCOUNT_ACTION_IDS.ACCOUNT_FLAG_QUIT,
    actionType: AccountActionTypes.USER_FLOW,
    pathToData: 'data',
  },
  [ACCOUNT_EVENT_IDS.CONTACT_VERIFICATION_RESOLVED]: {
    actionId: ACCOUNT_ACTION_IDS.CONTACT_VERIFICATION_RESOLVED,
    actionType: AccountActionTypes.USER_FLOW,
    pathToData: 'data',
  },
  [ACCOUNT_EVENT_IDS.MYACCOUNT_START_REQUESTED]: {
    actionId: ACCOUNT_ACTION_IDS.MYACCOUNT_START,
    actionType: AccountActionTypes.USER_FLOW,
    pathToData: 'data',
  },
  [ACCOUNT_EVENT_IDS.MYACCOUNT_CANCEL_REQUESTED]: {
    actionId: ACCOUNT_ACTION_IDS.MYACCOUNT_CANCEL,
    actionType: AccountActionTypes.USER_FLOW,
    pathToData: 'data',
  },
  [ACCOUNT_EVENT_IDS.SAFER_GAMBLING_MODALS_START_REQUESTED]: {
    actionId: ACCOUNT_ACTION_IDS.SAFER_GAMBLING_MODALS_START,
    actionType: AccountActionTypes.USER_FLOW,
    pathToData: 'data',
  },
  [ACCOUNT_EVENT_IDS.OB_DEPOSIT_REQUESTED]: {
    actionId: ACCOUNT_ACTION_IDS.DEPOSIT_START,
    actionType: AccountActionTypes.REDIRECT,
    pathToData: 'data',
    defaultData: {
      desktop:
        'https://sports.williamhill{env}.com/acc/{obLang}/payment/deposit/{depositHtmlPage}.html?hide_header=1&source={regSource}{extraQryStrs}',
      mobile:
        'https://sports.williamhill{env}.com/mob/{obLang}/payment/deposit/{depositHtmlPage}.html?hide_header=1&source={regSource}{extraQryStrs}',
    },
  },
  [ACCOUNT_EVENT_IDS.NATIVE_EXTERNAL_PAGE_REQUESTED]: {
    actionId: ACCOUNT_ACTION_IDS.NATIVE_EXTERNAL_PAGE_OPEN,
    actionType: AccountActionTypes.REDIRECT,
    pathToData: 'data',
  },
  [ACCOUNT_EVENT_IDS.NATIVE_DOCUMENT_UPLOAD_REQUESTED]: {
    actionId: ACCOUNT_ACTION_IDS.NATIVE_DOCUMENT_UPLOAD_OPEN,
    actionType: AccountActionTypes.REDIRECT,
    pathToData: 'data',
  },
};
